import { ArgumentError } from '../utils/errors';
import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

export default class AnalyticsModel extends BaseAPIModel {
    fields() {
        return {
            code_analytics: {},
            facebook_id_pixel: {},
            google_tag_manager: {}
        };
    }

    /**
     * Save item to API
     */
    save(...args) {
        return this.constructor.save(this, ...args);
    }

    static save(objects, ...args) {
        let data = objects.toAPI();
        let url = this.getListUrl(...args);

        return fetcher.patch(url, { data });
    }

    static list(item) {
        return item;
    }

    static listUrl({ organizationId, eventId }) {
        if (!organizationId || !eventId) {
            throw new ArgumentError(`[Model][AttendeeModel][getAll] organizationId and eventId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/events/${eventId}/analytics`;
    }
}
